// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b91afc0a","455":"f4a19c94","977":"d9e7fd6f"}[chunkId] + ".chunk.js";
};